module.exports = __webpack_public_path__ + "/images/logo-cta-elboletin.7f84274.png";